import { Injectable, signal } from '@angular/core';

@Injectable()
export class AdminNotificationsCatalogQuery {
  readonly query = signal('');
}
